import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_PRD_BAS_REG_013 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region Component UseState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [sharedForm, setSharedForm] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [gridFocus, setGridFocus] = useState(false);
  //#endregion

  //#region Variables
  const SharedFormref1 = useRef<any>();
  const gridref1 = useRef<any>(null);
  const { userInfo } = global();
  const selectedTabPage = useRef<any>(1);
  const searchRef = useRef<any>(null);
  //#endregion

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_PRD_BAS_REG_013";
  const defaultSize = {
    panel1width: "49.5%",
    panel2width: "49.5%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      try {
        const rtn: any = await getInitFormData();
        setSharedForm(rtn.form.freeform1);
        setColums(rtn.grid.grid1);
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridref1.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  //#region Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridref1.current.getChange();
    if (modifiedRowsH.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const params = {
        id: "sn_prd_bas_reg_013_01",
        params: searchRef.current.getFormdata(),
      };
      setFocusedRowData(null);

      setDataSource1([]);

      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);

      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));

        setGridFocus(true);
      }

      gridref1.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onInsert = () => {
    try {
      const newRow = {};
      gridref1.current.addRow(newRow);
      setTimeout(() => {
        gridref1.current.api.setFocusedCell(
          gridref1.current.api.getDisplayedRowCount() - 1,
          "cd_wo"
        );
      }, 50);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const searchFormData = searchRef.current.getFormdata();
      const rowCount = gridref1.current.api.getDisplayedRowCount();
      const selectedRows = gridref1.current.api.getSelectedNodes();
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        yn_use: "Y",
        yn_autorel: "N",
        yn_autorcv: "N",
        yn_prosct: "N",
        yn_default: "N",
        cd_io_rcv: "330",
        cd_io_isu: "310",
        cd_wo: "",
        nm_wo: "",
        dc_rmk: "",
        st_qt: "",
        yn_autoreq: "",
      };

      if (searchFormData.cd_biz === "" || searchFormData.cd_biz === null) {
        if (rowCount > 1) {
          updatedRow.cd_biz = selectedRows[0].data?.cd_biz;
        } else {
          updatedRow.cd_biz = "P";
        }
      } else {
        updatedRow.cd_biz = searchFormData.cd_biz;
      }

      Object.assign(newRow, updatedRow);
      return true;
    } catch (error: any) {
      return false;
    }
  };

  const onDelete = async () => {
    if (selectedTabPage.current === 1) {
      const focusedCell = gridref1?.current.api.getFocusedCell();
      let rowIndex: any = 0;

      if (focusedCell) {
        rowIndex = focusedCell.rowIndex;
      }
      // else{
      //   return;
      // }
      // const confirm = await showDialog("confirm", "삭제하시겠습니까?");

      // if (!confirm) {
      //   return; // 사용자가 아니오를 선택하면 함수 종료
      // }
      gridref1.current?.deleteSelectedRows();

      if (rowIndex === 0) {
        setFocusedRowData(null);
      } else {
        gridref1.current?.selectAndFocusRow(rowIndex - 1);
      }
    }
  };

  const onSave = async () => {
    try {
      gridref1.current.api.stopEditing();
      const requiredValuesCheck = gridref1.current.requiredValuesCheck();
      if (!requiredValuesCheck) {
        return;
      }

      const gridGetChanges = gridref1.current.getChange();
      if (gridGetChanges.modifiedRowcount == 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      const mas_wotype = gridref1.current.getChange();
      const hasInvalidCdPo = [
        ...(mas_wotype.insert || []),
        ...(mas_wotype.update || []),
      ].some((item) => item.cd_wo && item.cd_wo.length > 6);

      const hasInvalidNmso = [
        ...(mas_wotype.insert || []),
        ...(mas_wotype.update || []),
      ].some((item) => item.nm_wo && item.nm_wo.length > 100);

      if (hasInvalidCdPo) {
        const confirm = await showDialog(
          "alter",
          "수주형태코드가 6자리를 초과하였습니다."
        );
        return;
      }
      if (hasInvalidNmso) {
        const confirm = await showDialog(
          "alter",
          "수주형태코드가 100자리를 초과하였습니다."
        );
        return;
      }
      let SaveData: any = {};
      SaveData["mas_wotype"] = gridref1.current.getChange();
      await fnSave("SN_PRD_BAS_REG_013_SAVE_01", SaveData);
      gridref1.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#endregion

  //#region  Event Method
  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    },
    [focusedRowData]
  );
  //#endregion

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="flex h-full w-full min-w-0 space-x-1.5 overflow-y-hidden">
        <SnResizable
          direction={"width"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1width}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
        >
          <SnGrid
            seq={1}
            ref={gridref1}
            
            enableAddRow={true}
            columnConfig={columns} // 컬럼 설정 전달
            rowData={dataSource1}
            enableExternalChart={false}
            isEditable={false}
            rowSelection="single" // 단일 선택 모드
            onFocusedRowChanged={onFocusedRowChanged}
            onBeforeAddRow={onBeforeAddRowH}
            cellSelection={false}
            resizeController={{
              defaultSize: defaultSize,
              onResizeStop: onResizeStop,
            }}
            title="생산형태"
          />
        </SnResizable>
        <SnResizable
          direction={"width"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2width}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
        >
          <SharedForm
            ref={SharedFormref1}
            data={focusedRowData}
            controls={sharedForm}
            gridref={gridref1}
            
            title="상세정보"
          ></SharedForm>
        </SnResizable>
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_BAS_REG_013;
